import { AxiosRestApplicationClient as PricingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/pricing-app';
import {
  generateBaseAxiosClient,
  INotificationService,
  NotificationsService,
} from '@g2-shared/common';

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const PricingApiClient = new PricingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);

interface DIContextInterface {
  NotificationService: () => INotificationService;
  PricingApiClient: PricingAxiosRestApplicationClient;
}

export const DIContext = (): DIContextInterface => ({
  NotificationService: NotificationsService,
  PricingApiClient,
});
